"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var TwitterSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M14.77888,6.81633388 C14.77888,6.70702802 14.77888,6.59821454 14.77168,6.48989341 C15.2535191,6.13238983 15.6694506,5.68973485 16,5.18265444 C15.5506619,5.38688986 15.0739981,5.52082739 14.58592,5.579996 C15.0998771,5.26437881 15.4845393,4.7679677 15.66832,4.18314592 C15.1850356,4.47731423 14.6563101,4.68462939 14.10496,4.79614499 C13.3417997,3.9637436 12.1291453,3.76001043 11.1469837,4.29918735 C10.164822,4.83836426 9.657412,5.98636058 9.90928,7.0994459 C7.92970995,6.99764844 6.08534837,6.03855046 4.8352,4.46084188 C4.18173892,5.61477926 4.51551418,7.09100645 5.59744,7.83209057 C5.20563578,7.82017896 4.8223741,7.71176214 4.48,7.51598985 C4.48,7.52632959 4.48,7.5371617 4.48,7.54799381 C4.4803207,8.75015784 5.30644071,9.78558082 6.4552,10.0236238 C6.09273741,10.1250222 5.71243868,10.1398446 5.34352,10.0669522 C5.66605501,11.0957187 6.59035579,11.8004761 7.64368,11.8207696 C6.77187282,12.5235925 5.69490857,12.9051269 4.58608,12.9039808 C4.39019371,12.9035951 4.19449795,12.8914291 4,12.8675456 C5.12590526,13.6086967 6.43595843,14.0018237 7.77376,14 C12.30208,14.0019631 14.77888,10.1536091 14.77888,6.81633388 Z" })));
};
TwitterSmall.displayName = 'TwitterSmall';
exports.default = TwitterSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TwitterSmall.js.map